<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">海报设置</div>
      <div style="display: flex">
        <div class="bg" :style="{backgroundImage:'url(' + api.temp.FILE_PATH + fissionPosterImg + ')'}">

          <VueDragResize v-if="hd.show"
                         ref="VueDragResize"
                         :isActive="true" :w="hd.width" :h="hd.height" :x="hd.xaxis" :y="hd.yaxis" :parentW="375"
                         :parentH="667"
                         :parentLimitation="true"
                         @resizing="resize" @dragging="resize"
          >
            <a-avatar :src="require('@/assets/img/moren.png')" class="hd"/>
          </VueDragResize>
          <VueDragResize v-if="name.show" ref="VueDragResize1" :isActive="true" :w="name.width" :h="name.height"
                         :x="name.xaxis"
                         :y="name.yaxis"
                         :parentW="375"
                         :parentH="667"
                         :parentLimitation="true"
                         @resizing="resize2" @dragging="resize2"
          >
            <div :style="{color: name.color,fontSize: staffNameSize + 'px'}" class="name">昵称</div>
          </VueDragResize>
          <VueDragResize v-if="ewm.show" ref="VueDragResize2" :isActive="true" :w="ewm.width" :h="ewm.height"
                         :x="ewm.xaxis"
                         :y="ewm.yaxis" :parentW="375"
                         :parentH="667"
                         :parentLimitation="true"
                         @resizing="resize1" @dragging="resize1"
          >
            <img src="@/assets/img/ewm.jpg" alt="" style="width: 100%">
          </VueDragResize>
          <!--          <p :style="{color: ewm.color,top:ewm.yaxis + ewm.height + 20 + 'px'}" class="text">扫描二维码添加好友，为XXX助力</p>-->
        </div>
        <div class="form">
          <div class="item"><span>*</span> 上传海报背景图
            <uploader :num="1" v-model="fissionPosterImg" :accept="'image/*'"
                      :url="api.temp.UPLOAD_PATH"
            ></uploader>
            只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，不超过5M
          </div>
          <div class="keys">
            <p>展示字段</p>
            <ul>
              <li v-show="false">裂变二维码
                <a-switch :defaultChecked="ewm.show" @click="ewm.show = !ewm.show;$forceUpdate()"/>
              </li>
              <li>分享人头像
                <a-switch :defaultChecked="hd.show" @click="hd.show = !hd.show;$forceUpdate()"/>
              </li>
              <li>分享人昵称
                <a-switch :defaultChecked="name.show" @click="name.show = !name.show;$forceUpdate()"/>
              </li>
              <li>昵称颜色
                <colorPicker v-model="name.color" @change="headleChangeColor" style="border: 1px solid #000"/>
              </li>
              <!--              <li>文案颜色-->
              <!--                <colorPicker v-model="ewm.color" @change="headleChangeColor"/>-->
              <!--              </li>-->
              <li>
                文字大小
                <a-radio-group v-model="staffNameSize">
                  <a-radio-button :value="16">
                    小
                  </a-radio-button>
                  <a-radio-button :value="20">
                    中
                  </a-radio-button>
                  <a-radio-button :value="24">
                    大
                  </a-radio-button>
                </a-radio-group>
              </li>
            </ul>
          </div>
          <div>
            海报上的展示字段可拖动调整位置，点击后拖动边框调整大小
          </div>
        </div>
      </div>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="lastStep">上一步</a-button>
      <a-button type="primary" @click="submit">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import VueDragResize from 'vue-drag-resize'
import vcolorpicker from 'vcolorpicker'

Vue.use(VueDragResize)
Vue.use(vcolorpicker)

import {formMixin} from '@/utils/common/FormBase'
import {dataApi} from "@/services/operate/marketingFission";

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function _loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.staffNameSize = entity.data.staffNameSize || 16
  this.fissionPosterImg = entity.data.fissionPosterImg
  this.detail = entity.data
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  const vm = this

  let entities = this.detail
  entities.addLayoutList = [vm.hd, vm.name, vm.ewm].map(item => {
    item.show ? item.isShow = 1 : item.isShow = 0
    return item
  })
  if( !vm.fissionPosterImg){
    this.$message.error('请上传海报背景图')
    return false

  }
  entities.fissionPosterImg = vm.fissionPosterImg
  entities.staffNameSize = vm.staffNameSize
  await dataApi.saveFormDetail(entities).then(res => {
    if (res.code === 200) {
      this.$emit('nextStep', res.data.fissionId)
    } else {
      this.$message.error(res.msg)
    }
  })
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {VueDragResize},
  props: ['layoutList'],
  created() {
    if (this.layoutList.length > 0) {
      this.layoutList.forEach(item => item.show = item.isShow === 1)
      console.log(this.layoutList)
      this.hd = this.layoutList.find(item => item.name === 'head')
      this.name = this.layoutList.find(item => item.name === 'name')
      this.ewm = this.layoutList.find(item => item.name === 'ewm')
    }
  },
  data() {
    return {
      hd: {
        width: 70,
        height: 70,
        yaxis: 16,
        xaxis: 16,
        name: 'head',
        isShow: 1,
        show: true
      },
      name: {
        name: 'name',
        color: '#ff0000',
        width: 50,
        height: 50,
        yaxis: 20,
        xaxis: 87,
        isShow: 1,
        show: true
      },
      ewm: {
        width: 100,
        height: 100,
        yaxis: 400,
        xaxis: 137,
        name: 'ewm',
        color: '#ff0000',
        isShow: 1,
        show: true
      },
      staffNameSize: 16,
      fissionPosterImg: '',
      detail: null
    }
  },
  mounted() {

  },
  methods: {
    _loadEntity,
    submit,
    loadBaseData,
    resize(newRect) {
      this.hd.width = newRect.width;
      this.hd.height = newRect.height;
      this.hd.yaxis = newRect.top;
      this.hd.xaxis = newRect.left;
    },
    resize1(newRect) {
      this.ewm.width = newRect.width;
      this.ewm.height = newRect.height;
      this.ewm.yaxis = newRect.top;
      this.ewm.xaxis = newRect.left;
    },
    resize2(newRect) {
      this.name.width = newRect.width;
      this.name.height = newRect.height;
      this.name.yaxis = newRect.top;
      this.name.xaxis = newRect.left;
    },
    headleChangeColor(value) {
      console.log(value)
    },
    lastStep() {
      this.$emit('lastStep')
    },
    handleClick() {
      this.$set(this.hd, 'show', true)
    }
  }
};
</script>
<style lang="less" scoped>
.bg {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px solid #000;
  background-repeat: no-repeat;
  background-size: cover;
}

.hd {
  width: 100%;
  height: 100%;
}

.name {
  font-weight: bold;
}

.form {
  flex: 1;
  margin-left: 24px;

  .item {
    color: #333;

    span {
      color: #D90B18;
    }
  }

  .keys {
    display: flex;
    margin: 16px 0;

    li {
      margin-bottom: 12px;
    }
  }
}

/deep/ .m-colorPicker {
  top: 3px
}
/deep/ .m-colorPicker .box.open {
  z-index: 10 !important;
}
.text {
  text-align: center;
  position: absolute;
  width: 100%;
}
</style>
